export const getErrorFromMeta = meta => meta && (meta.touched || meta.dirty || !!meta.initial) && meta.error
export const formatSecToMin = v => v / 60 || 0
export const parseMinToSec = v => v * 60 || 0
